import { render, staticRenderFns } from "./TaskRowHoverActions.vue?vue&type=template&id=088d719f&scoped=true"
import script from "./TaskRowHoverActions.vue?vue&type=script&lang=js"
export * from "./TaskRowHoverActions.vue?vue&type=script&lang=js"
import style0 from "./TaskRowHoverActions.vue?vue&type=style&index=0&id=088d719f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088d719f",
  null
  
)

export default component.exports